import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/staff/$staffId")({
  head: () => ({
    meta: [{ title: "员工详情 · imiker CRM" }],
  })
});
